<h1>{{'healthInsurance' | translate}}</h1>
<div class="row">
  <div class="col-md-12 col-lg-12">
    <healthinsurance-table #emptable [healthInsurances]="healthInsurances" (healthInsuranceSelected)="setSelectedHealthInsurance($event)" (addHealthInsuranceClicked)="openAddEmployeeBottomSheet()" (refresh)="getHealthInsurances()"></healthinsurance-table>
  </div>
</div>
